import { apiClient } from "./apiClient";
import {
  FETCH_BRANDS,
  FETCH_MODEL_BY_BRANDID,
  FETCH_VARIANTS_BY_MODEL,
} from "./endpoints";

export class MMVService {
  static async getBrands() {
    return await apiClient.get(FETCH_BRANDS);
  }

  static async getModels(makeId: number) {
    return await apiClient.get(`${FETCH_MODEL_BY_BRANDID(makeId)}`);
  }

  static async getVariants(makeId: number, modelId: number) {
    return await apiClient.get(`${FETCH_VARIANTS_BY_MODEL(makeId, modelId)}`);
  }

  //   static async getFullCatalog(makeId: string, modelId: string) {
  //     try {
  //       const brands = await this.getBrands();
  //       const models = await this.getModels(makeId);
  //       const variants = await this.getVariants(makeId, modelId);

  //       return { brands, models, variants };
  //     } catch (error) {
  //       console.error("Failed to load catalog data:", error);
  //       throw error;
  //     }
  //   }
}
